export const getHoursFormat = () => { // options: 12-hour or 24-hour
  // Create a Date object
  const date = new Date();

  // Format the time based on the user's locale
  const timeString = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  // Check if the time string contains "AM" or "PM"
  const is12Hour = timeString.toLowerCase().includes('am') || timeString.toLowerCase().includes('pm');
  return is12Hour ? '12-hour' : '24-hour';
};

export const getFormattedTimeByHoursFormat = (hour, minute) => {
  const is12Hour = getHoursFormat() === '12-hour';
  if (!is12Hour) {
    if (hour > 23) {
      hour = 0;
    }
    return `${padWithZero(hour)}:${minute}`;
  }

  if (hour === 24) {
    return `12:${minute} AM`;
  } else if (hour > 12) {
    return `${padWithZero(hour % 12)}:${minute} PM`;
  } else if (hour === 12) {
    return `${hour}:${minute} PM`;
  } else if (hour === 0) {
    return `12:${minute} AM`;
  } else {
    return `${padWithZero(hour)}:${minute} AM`;
  }
}

export const padWithZero = (number) => {
  return number < 10 ? `0${number}` : number;
}

export const timestampToDate = (timestamp) => {
  return new Date(timestamp).toLocaleDateString();
};

export const timestampToTime = (timestamp, showHours = true, showMinutes = true, showSeconds = true) => {
  const date = new Date(timestamp);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  let time = "";
  if (showHours) {
    time += `${hours < 10 ? "0" : ""}${hours}`;
  }
  if (showMinutes) {
    time += `:${minutes < 10 ? "0" : ""}${minutes}`;
  }
  if (showSeconds) {
    time += `:${seconds < 10 ? "0" : ""}${seconds}`;
  }

  return time;
  // return new Date(timestamp).toLocaleTimeString();
};

export const secondsToTime = (seconds) => {
  if (isNaN(seconds)) {
    return "00:00";
  }
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // return time with 0 padding if needed
  return `${minutes < 10 ? "0" : ""}${minutes}:${
    remainingSeconds < 10 ? "0" : ""
  }${remainingSeconds}`;
};
